import { ChangeEvent, useState } from "react";
import { TextField } from "@mui/material";
import { debounce } from "lodash";
import { CardData } from "@/interfaces";
import { parseCard, isCardNumber, toCardData } from "@/utils";
import { colors } from "@/theme";
import { CustomTextField } from "@/components/pages/Checkout/customStyles";

export type CardNumberInputProps = {
  cardNumber?: string;
  numberLength?: number | number[];
  onChange?: (cardData?: CardData) => void;
  fullWidth?: boolean;
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
};

const process = debounce(
  (
    value?: string,
    numberLength?: number | number[],
    setValue?: Function,
    onChange?: Function
  ) => {
    const card = parseCard(value);
    if (card) {
      if (isCardNumber(card.cardNumber, numberLength)) {
        setValue?.((prev: string | undefined) => {
          console.log(
            "CardNumberInput handleInputChange setValue(%o => %o)",
            prev,
            card.cardNumber
          );
          return card.cardNumber;
        });

        onChange?.(
          toCardData(
            card.cardNumber,
            card.expirationMonth,
            card.expirationYear,
            card.firstMiddleName,
            card.lastName
          )
        );
      }
    } else if (isCardNumber(value, numberLength)) {
      onChange?.(toCardData(value));
    }
  },
  1000
);

const CardNumberInput: React.FC<CardNumberInputProps> = ({
  cardNumber = undefined,
  numberLength = undefined,
  onChange = undefined,
  fullWidth = false,
  placeholder = undefined,
  disabled = undefined,
  autoFocus = undefined,
}) => {
  console.log("CardNumberInput() started");

  const [value, setValue] = useState<string | undefined>(cardNumber);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = e.target.value;

    setValue((prev: string | undefined) => {
      console.log(
        "CardNumberInput handleInputChange setValue(%o => %o)",
        prev,
        value
      );
      return value;
    });

    process(value, numberLength, setValue, onChange);
  };

  return (
    <CustomTextField
      value={value}
      onChange={handleInputChange}
      fullWidth={fullWidth}
      placeholder={placeholder}
      disabled={disabled}
      autoFocus={autoFocus}
      sx={{
        "& .MuiInputBase-root": {
          // backgroundColor: colors.fieldBg,
          "font-family": "PF DIN Text Pro",
          "font-size": "16px",
          "font-style": "normal",
          "font-weight": "400",
          "line-height": "16px",
          maxHeight: "41px",
        },
      }}
    />
  );
};

export default CardNumberInput;
